import { useContext } from 'react';
import {
  InstallPromptContext,
  type InstallPromptContextValue,
} from '@providers/InstallPromptContext';
import { defineStoredValue, FINITE_NUMBER } from '@utils/storedValue';

// ── Re-export type for consumers ──

export type UseInstallPromptReturn = InstallPromptContextValue;

// ── Navigation counter utilities (used by InstallPromptInitializer) ──

const navCountStore = defineStoredValue({
  storage: 'session',
  key: 'pwa_install_nav_count',
  ...FINITE_NUMBER,
});

export function getNavCount(): number {
  return navCountStore.read() ?? 0;
}

export function incrementNavCount(): number {
  const count = getNavCount() + 1;
  navCountStore.write(count);
  return count;
}

// ── Hook (context consumer) ──

export function useInstallPrompt(): UseInstallPromptReturn {
  const context = useContext(InstallPromptContext);
  if (!context) {
    throw new Error('useInstallPrompt must be used within InstallPromptProvider');
  }
  return context;
}
